import CryptoJS from "crypto-js";
export const decryptOpenSSLAES = (encryptedBase64) => {
    const passphrase = "AGGRE@$*&#(!@%^&"; // your key

    if (!encryptedBase64) return null;

    // Decode base64
    const data = CryptoJS.enc.Base64.parse(encryptedBase64);

    // Extract header "Salted__"
    const header = CryptoJS.enc.Utf8.stringify(
        CryptoJS.lib.WordArray.create(data.words.slice(0, 2))
    );

    if (header !== "Salted__") {
        throw new Error("Invalid encrypted OpenSSL data");
    }

    // Extract salt
    const salt = CryptoJS.lib.WordArray.create(data.words.slice(2, 4));

    // Extract ciphertext
    const ciphertext = CryptoJS.lib.WordArray.create(data.words.slice(4));

    // Generate OpenSSL key + IV using MD5 loops
    let keyIv = CryptoJS.lib.WordArray.create();
    let last = CryptoJS.lib.WordArray.create();

    while (keyIv.sigBytes < 48) {
        last = CryptoJS.MD5(
            CryptoJS.lib.WordArray.create([
                ...last.words,
                ...CryptoJS.enc.Utf8.parse(passphrase).words,
                ...salt.words,
            ])
        );
        keyIv = CryptoJS.lib.WordArray.create([...keyIv.words, ...last.words]);
    }

    const key = CryptoJS.lib.WordArray.create(keyIv.words.slice(0, 8));   // 32 bytes
    const iv = CryptoJS.lib.WordArray.create(keyIv.words.slice(8, 12));   // 16 bytes

    // Decrypt
    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext },
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
};

export const safeDecrypt = (value) => {
    if (!value || typeof value !== "string") return "-";

    // OpenSSL encrypted strings usually start with this
    if (!value.startsWith("U2FsdGVkX1")) {
        return value; // already plain text
    }

    try {
        return decryptOpenSSLAES(value);
    } catch (e) {
        console.error("Decrypt failed:", value);
        return "-";
    }
};
